/**
 * Created by tomers on 5/7/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/skills/skillLoadBalanceSection.tmpl");
    var Button = require("ui/button/Button");
    var InputField = require("ui/input-field/InputField");
    var SingleSelect = require("ui/singleselect-new/Singleselect");

    var SkillLoadBalanceSectionView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        SkillLoadBalanceSectionView = Marionette.ItemView.extend({
            className: "skill-load-balance-section",
            template: template,
            ui:{
                selectGroup: ".select-group",
                loadLabel: ".load-label",
                splitPercentage: ".split-percentage",
                percentage: ".percentage",
                delete: ".delete"
            },
            uiComponents: {
                agentGroupId: {
                    type: SingleSelect,
                    options: {
                        container: "view.ui.selectGroup",
                        permutation: SingleSelect.PERMUTATION.E,
                        theme: SingleSelect.THEME.DEFAULT,
                        inputField: {
                            placeholder: LE.translator.translate("LEUserManagement.skillEdit.load.balancing.select.group")
                        },
                        list: {
                            maxShownItems: 5
                        },
                        items : "view._getAgentGroupItems"
                    },
                    events: {
                        "change": "_onAgentGroupChange",
                        "blur": "_onAgentGroupBlur"
                    }
                },
                splitPercentage: {
                    type: InputField,
                    options: {
                        el: "view.ui.splitPercentage",
                        permutation: InputField.Permutation.K,
                        inputType: InputField.prototype.InputTypeEnum.WholeNumber,
                        maxLength: 3
                    },
                    events: {
                        change: "_onSplitPercentageChange"
                    }
                }
            },
            events: {
                "click .delete" : "_onDeleteClick"
            },
            modelEvents: {
                "change": "_onModelChange"
            },

            getModel: function() {
                return this.model;
            },

            //<editor-fold desc="Marionette-Functions">
            /*-----------------------------------------------------------------------------------------------*/
            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            //</editor-fold>

            //<editor-fold desc="publicFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            //</editor-fold>


            //<editor-fold desc="privateFunctions">
            /*-----------------------------------------------------------------------------------------------*/
            _initialize: function(options) {
                this.model = options.model;
                this.agentGroupsCollection = options.agentGroupsCollection;
                this.channel = options.channel;
            },

            _onRender: function() {
                this._updateAgentGroupId();
                this._updateSplitPercentage();
            },

            _updateAgentGroupId: function() {
                var agentGroupId = this.model.getAgentGroupId();
                if(!_.isUndefined(agentGroupId) && agentGroupId !== "") {
                    var agentGroupName = this.agentGroupsCollection.get(this.model.getAgentGroupId()).getName();
                    this.uiComponents.agentGroupId.setInputValue(agentGroupName);
                }
            },

            _updateSplitPercentage: function() {
                if(!_.isUndefined(this.model.getSplitPercentage())) {
                    this.uiComponents.splitPercentage.setValue(this.model.getSplitPercentage());
                }
            },

            _onAgentGroupChange: function(componentId, eventName, obj) {
                var agentGroupItem = this.uiComponents.agentGroupId.getSelectedItem();
                if (!_.isEmpty(agentGroupItem)) {
                    var agentGroupId = agentGroupItem.id;
                    this.model.setAgentGroupId(agentGroupId);
                    this.channel.trigger("loadBalance:change:agentGroupId", agentGroupId);
                }
                this._clearErrors();
            },

            _clearErrors: function() {
                this.uiComponents.agentGroupId.setError(false);
            },

            _onAgentGroupBlur: function(){
                var agentGroupVal = this.uiComponents.agentGroupId.getInputValue();
                var agentGroupObj = this.uiComponents.agentGroupId.getSelectedItem();
                if (!_.isEmpty(agentGroupVal)) {  // only if not empty value
                    if (_.isEmpty(agentGroupObj)) {
                        this.uiComponents.agentGroupId.setError(true, LE.translator.translate("LEUserManagement.skillEdit.load.balancing.agent.group.validation.unknown.group"));
                        return false;
                    } else {
                        this.uiComponents.agentGroupId.setInputValue(agentGroupObj.value);
                    }
                }
                return true;
            },

            _onSplitPercentageChange: function(componentId, eventName, value) {
                if("" !== value) {
                    value = parseInt(value, 10);
                }
                if(!_.isNaN(value)) {
                    this.model.setSplitPercentage(value);
                    this.channel.trigger("loadBalance:change:splitPercentage", value);
                }
            },

            _getAgentGroupItems: function() {
                var mainGroup = this.agentGroupsCollection.getMainGroup();

                var agentGroupArr = [];
                this.agentGroupsCollection.each(function(model) {
                    if (!mainGroup || mainGroup.id !== model.id) {
                        var agentGroupObj = {
                            id: model.id,
                            value: model.getName()
                        };
                        agentGroupArr.push(agentGroupObj);
                    }
                }, this);

                return agentGroupArr;
            },

            _onDeleteClick: function() {
                this.channel.trigger("loadBalance:delete", {model: this.model, loadBalanceId : this.model.getLoadBalanceId()});
            },

            _onModelChange: function() {
                this.channel.trigger("loadBalance:model:changed", {valueIsChanged: true});
            },

            setErrors: function(errors) {
                this._hideErrors();

                if (_.has(errors, this.model.KEYS.AGENT_GROUP_ID)) {
                    this.uiComponents.agentGroupId.setError(true, errors[this.model.KEYS.AGENT_GROUP_ID]);
                }

                if (_.has(errors, this.model.KEYS.SPLIT_PERCENTAGE)) {
                    this.uiComponents.splitPercentage.setError(true, errors[this.model.KEYS.SPLIT_PERCENTAGE]);
                }
            },

            _hideErrors: function () {
                this.uiComponents.agentGroupId.setError(false);
                this.uiComponents.splitPercentage.setError(false);
            }
            //</editor-fold>
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return SkillLoadBalanceSectionView;

});
